import '../../css/SplashScreen.css'
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NotificationManager } from 'react-notifications';
import { Button, Checkbox, Dialog, FormControlLabel, Typography, DialogTitle, DialogContent, DialogActions, IconButton, Box, Grid, Tooltip, TextField } from '@mui/material';
import SFInfoIcon from '../../SF/SFPages/SFTakequiz/components/SFInfoIcon';
import SFGoalSlider from '../../SF/SFPages/SFTakequiz/components/SFGoalSlider';
import ApiRequestService from '../../components/ApiRequestService';
import "../../SF/SFPages/SFTakequiz/components/goalDialogStyle.css"
import {  FaUndo } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa6';
import { BeatLoader } from 'react-spinners';


var style = {
    backgroundColor: "#F8F8F8",
    borderTop: "1px solid #E7E7E7",
    textAlign: "center",
    padding: "20px",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "60px",
    width: "100%",
}

var phantom = {
    display: 'block',
    padding: '20px',
    height: '60px',
    width: '100%',
}


class FreeChoiceCategorySelectionPage extends Component {
    constructor(props) {
        super(props);
        let tempCategoryMap = props.categories

        /* Object.keys(tempCategoryMap).forEach(function(key) {
                 tempCategoryMap = {
                     ...tempCategoryMap,
                     [key]:{
                         ...tempCategoryMap[key],
                         isRequired : props.categoryIsRequired[key] === 1 ? true :false,
                         categoryKey:key
                     }
                 }
         });*/
        console.debug("tempCategoryMap", tempCategoryMap)
        this.state = {
            categories: [],
            loading: false,
            showSaved: false,
            lastQuestionAnswerState: null,
        };
        this.onRowClick = this.onRowClick.bind(this);
        this.onCheckBoxClick = this.onCheckBoxClick.bind(this);
        console.debug("props>>??", props)

    }

    componentDidMount() {
        console.debug("componentDidMount CALLED")
        // If courseID = -1, then it's a practice set, so select all the categories and call the onStartQuiz function
        /*  if (this.props.courseID === -1) {
             let updatedCategories = this.state.categories.map(category => {
                 return { ...category, is_selected: 1 };
             });
             console.debug("updatedCategories", updatedCategories)
             this.props.onStartQuiz(updatedCategories)
         } */
        this.getCategoriesData();
        this.getQuestionAnswerState();
    }

    getQuestionAnswerState = () => {
        this.setState({
            loading: true
        })
        ApiRequestService({
            method: 'post',
            url: '/getQuestionAnswerStates',
            data: {
                quiz_id: this.props.quizID,
            },
        }).then(res => {
            if (res && res.data && res.data.data) {
                let questionAnswerStates = res.data.data;
                if (questionAnswerStates && questionAnswerStates.length) {
                    this.setState({
                        lastQuestionAnswerState: questionAnswerStates[0],
                    })
                }
            }
        }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    deleteAllQuestionAnswerState = () => {
        this.setState({
            loading: true,
        })
        return ApiRequestService({
            method: 'post',
            url: '/deleteAllQuestionAnswerState',
            data: {
                quiz_id: this.props.quizID,
            },
        });
    }

    componentDidUpdate(_, prevState){
        if (prevState.categories?.length !== this.state.categories?.length) {
            
        }
    }

    getCategoriesData = () => {
        console.debug("this.props.quizID>>??", this.props.quizID)
        if (this.props.quizID) {
            this.setState({
                loading: true
            })
            ApiRequestService({
                method: 'post',
                url: '/getCategoriesByQuizID',
                data: {
                    quizID: this.props.quizID,
                    practiceCount: this.props.practiceCount,
                    parentQuizID: this.props.parentQuizID,
                }
            }).then(res => {
                if (res && res.data && res.data.category_names) {
                    let updatedCategories = this.props.categoryIsRequired.map(cat => {
                        let id = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                        let categoryData = res.data.category_names.find(catName => {
                            let id2 = `${catName.subject_id}_${catName.topic_id}_${catName.category_id}`;
                            return id == id2;
                        })

                        let isAccuracyGoalSet = categoryData.isAccuracyGoalSet;
                        console.debug("categoryData>>??", categoryData);
                        if (categoryData.accuracyGoal === categoryData.defaultAccuracyGoal) {
                            isAccuracyGoalSet = false;
                        }

                        let isTimeGoalSet = categoryData.isTimeGoalSet;
                        if (categoryData.timeGoal === categoryData.defaultTimeGoal) {
                            isTimeGoalSet = false;
                        }
                        return {
                            ...cat,
                            accuracyGoal: categoryData.accuracyGoal,
                            timeGoal: categoryData.timeGoal,

                            currentAccuracyGoal: categoryData.currentAccuracyGoal,
                            currentTimeGoal: categoryData.currentTimeGoal,

                            defaultAccuracyGoal: categoryData.defaultAccuracyGoal,
                            defaultTimeGoal: categoryData.defaultTimeGoal,

                            isAccuracyGoalSet: isAccuracyGoalSet,
                            isTimeGoalSet: isTimeGoalSet,

                            previousAccuracyGoal: categoryData.previousAccuracyGoal,
                            previousTimeGoal: categoryData.previousTimeGoal,

                        }
                    });

                    updatedCategories.sort((a, b) =>
                        a.category_name.localeCompare(b.category_name, undefined, { sensitivity: 'base' })
                    );
                    if (this.props.isTutorial) {
                        // the make all categories is_selected = 1
                        updatedCategories = updatedCategories.map(cat => {
                            return {
                                ...cat,
                                is_selected : 1,
                            }
                        });
                    }
                    this.setState({
                        categories: updatedCategories,
                    }, () => {
                        if (this.props.isTutorial) {
                            this.quizStartOnClick();
                        }
                    })
                }
            }).catch(err => console.log("errr", err))
                .finally(() => {
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    onRowClick = (key) => {
        let temp = this.state.categories
        let index = temp.findIndex((srcData) => {
            return srcData.category_key === key;
        });
        if (temp[index].is_required !== 1) {
            console.log("a,b", index, temp)
            temp = [
                ...temp.slice(0, index),
                {
                    ...temp[index],
                    is_selected: temp[index].is_selected === 1 ? 0 : 1
                },
                ...temp.slice(index + 1)
            ]
            console.log("temp", temp)

            this.setState({
                categories: temp
            })
        }
    }

    onCheckBoxClick(event, key) {
        console.log(event, "checkbox a,b", key)
        /*let temp = this.state.categories
        console.log(event,"checkbox a,b",key, temp)
        temp={
             ...temp,
             [key] : {
                 ...temp[key],
                 isRequired : !temp[key].isRequired
             }
         }
         console.log("temp", temp)
         this.setState({
             categories:temp
        })*/
    }

    quizStartOnClick = () => {
        let selectedCategories = 0;
        (this.state.categories).forEach((element, index) => {
            if (element.is_required === 2 && element.is_selected === 1) {
                selectedCategories++
            }
        })
        if (selectedCategories < this.props.freeChoiceCount) {
            if (this.props.practiceCount === 0) {
                NotificationManager.error("Please select atleast " + this.props.freeChoiceCount + (this.props.freeChoiceCount > 1 ? " categories" : " category") + " in free choice");
            } else {
                NotificationManager.error("Please select atleast 1 category from the list.");
            }
            return
        }

        // Check if lastQuestionAnswerState category is selected if not delete the question answer state and then start quiz
        console.debug("this.state.lastQuestionAnswerState", this.state.categories, this.state.lastQuestionAnswerState)
        if (this.state.lastQuestionAnswerState) {
            let exists = false;
            const lastQuestionCatKey = `${this.state.lastQuestionAnswerState.subject_id}_${this.state.lastQuestionAnswerState.topic_id}_${this.state.lastQuestionAnswerState.category_id}`;
            this.state.categories.forEach(selectedCat => {
                if (selectedCat.is_selected) {
                    let catKey = `${selectedCat.subject_id}_${selectedCat.topic_id}_${selectedCat.category_id}`;
                    if (lastQuestionCatKey == catKey) {
                        exists = true;
                    }
                }
                
            });
            console.debug("exists>>??", exists, lastQuestionCatKey, this.state.categories)
            if (exists === false) {
                // Remove the question answer state
                this.deleteAllQuestionAnswerState().then(() => {
                    this.handleSubmit(true);
                    this.setState({
                        loading: false,
                    })
                })
            } else {
                this.handleSubmit(false);
            }
        } else {
            this.handleSubmit(false);
        }

    }

    handleSubmit = (clearQuestionAnswerStates) => {
        if (this.props.practiceCount <= 0) {
            this.props.onStartQuiz(this.state.categories, clearQuestionAnswerStates);
        } else {
            this.handleSaveGoal(this.state.categories);
        }
    }

    handleAccuracyGoalChange = (newGoal, index) => {
        let updatedCategories = this.state.categories.map((category, i) =>
            i === index ? { ...category, isAccuracyGoalSet: newGoal !== category.defaultAccuracyGoal, accuracyGoal: newGoal } : category
        );
        this.setState({
            categories: updatedCategories
        })
        // this.handleSetAccuracyGoal(updatedCategories, index);
    }

    handleTimeGoalChange = (newGoal, index) => {
        let updatedCategories = this.state.categories.map((category, i) =>
            i === index ? { ...category, isTimeGoalSet: newGoal !== category.defaultTimeGoal, timeGoal: newGoal } : category
        );
        this.setState({
            categories: updatedCategories
        })
        // this.handleSetTimeGoal(updatedCategories, index);
    }

    handleSetAccuracyGoal = (updatedCategories, selectedCategoryIndex) => {
        if (this.props.quizID === null || this.props.quizID === undefined) {
            return
        }
        let category = updatedCategories[selectedCategoryIndex];
        updatedCategories[selectedCategoryIndex].isAccuracyGoalSet = true;
        let payload = {
            quizID: this.props.quizID,
            practiceCount: this.props.practiceCount,
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            accuracyGoal: category.accuracyGoal,
        }

        ApiRequestService({
            method: 'post',
            url: '/setAccuracyGoal',
            data: payload
        }).then(res => {
            this.setState({
                showSaved: true,
                categories: updatedCategories
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    handleSetTimeGoal = (updatedCategories, selectedCategoryIndex) => {
        if (this.props.quizID === null || this.props.quizID === undefined) {
            return
        }
        let category = updatedCategories[selectedCategoryIndex];
        updatedCategories[selectedCategoryIndex].isTimeGoalSet = true;
        let payload = {
            quizID: this.props.quizID,
            practiceCount: this.props.practiceCount,
            catKey: `${category.subject_id}_${category.topic_id}_${category.category_id}`,
            timeGoal: parseInt(category.timeGoal),
        }

        ApiRequestService({
            method: 'post',
            url: '/setTimeGoal',
            data: payload
        }).then(res => {
            this.setState({
                showSaved: true,
                categories: updatedCategories
            })
        }).finally(() => {
            this.setState({
                loading: false,
            })
        })
    }

    handleSaveGoal = (updatedCategories) => {
        let quizID = this.props.quizID;
        let practiceCount = this.props.practiceCount;
        if (quizID === null || quizID === undefined) {
            return
        }

        updatedCategories = updatedCategories.filter(cat => cat.is_selected);

        let payload = {
            quizID: quizID,
            practiceCount: practiceCount,
            categoryGoals: updatedCategories.map(cat => {
                return {
                    catKey: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`,
                    quizID: quizID,
                    accuracyGoal: cat.accuracyGoal,
                    timeGoal: parseInt(cat.timeGoal),
                }
            })
        }
        this.setState({ loading: true });
        ApiRequestService({
            method: 'post',
            url: '/setGoals',
            data: payload
        }).then(res => {
            this.props.onStartQuiz(updatedCategories)
        }).finally(() => {
            this.setState({ loading: false });
        })

    }

    handleResetAccuracyGoal = (catIndex) => {

        let updatedCategories = this.state.categories.map((category, i) =>
            i === catIndex ? {
                ...category,
                accuracyGoal: category.defaultAccuracyGoal,
                isAccuracyGoalSet: false,
            } : category
        );

        this.setState({
            categories: updatedCategories
        });
    }

    handleResetTimeGoal = (catIndex) => {
        let updatedCategories = this.state.categories.map((category, i) =>
            i === catIndex ? {
                ...category,
                timeGoal: category.defaultTimeGoal,
                isTimeGoalSet: false,
            } : category
        );
        this.setState({
            categories: updatedCategories
        });
    }

    render() {
        
        if (this.props.isTutorial) {
            // TODO add a loader
            return null
        }

        return <div className='w-100 h-100 position-relative'>
            <Dialog open={true} maxWidth="lg" fullScreen aria-labelledby='practice-categories-title'
                PaperProps={{
                    sx: {
                        minHeight: "100%"
                    }
                }}>
                <div style={{
                    background: "#eff1f2",
                    width: this.props.isMobile ? '100%' : '80%',
                    margin: '1rem auto',
                    borderRadius: '8px',

                }}>
                    <DialogTitle id='practice-categories-dialog-title' className='text-align-center my-2'>
                        <Typography id='practice-categories-title' component='h1' fontSize={24} fontWeight={600} color="primary">
                            {this.props.practiceCount > 0 ? "Choose Practice Categories & Goals" : "Free-Choice Category Selection"}
                        </Typography>

                        <div className='d-flex justify-content-between align-items-end'>
                            <Grid container>
                                <Grid item md={3}>
                                    <div className='d-flex align-items-center'>
                                        <div aria-hidden='true' style={{ width: '40px', height: '10px', background: '#FAA201' }}></div>
                                        <Typography className='ml-2' >
                                            Previous Attempt Progress
                                        </Typography>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <div aria-hidden='true' style={{ width: '40px', height: '5px', borderRadius: '4px', background: '#BA0C2F' }}></div>
                                        <Typography className='ml-2'>
                                            Goal for this assignment
                                        </Typography>
                                    </div>

                                </Grid>
                                {/* <Grid item md={3} className='d-flex justify-content-end align-items-center'>
                                    <div className='mr-5'>
                                        {this.state.loading ? <span><CircularProgress size={12} /> <small>Updating goal..</small> </span> : (this.state.showSaved ? <small style={{
                                            color: '#80C75B'
                                        }}> <FaCheckCircle color='#80C75B' /> Goal updated</small> : null)}
                                    </div>
                                </Grid> */}
                            </Grid>
                        </div>

                    </DialogTitle>
                    <DialogContent className='d-flex flex-column align-items-center justify-content-start mt-2'>
                        <div >
                            {this.props.practiceCount <= 0 ?
                                <Typography id='practice-categories-instructions' component='p'
                                    fontSize={16} fontWeight={500}>
                                    {`Below is list the categories that are "Required" (if any) and categories that are "Free Choice" for this assignment. 
                                There may be a minimum number of free choice categories you must choose to complete the assignment.`}<br /><br />
                                    {this.props.freeChoiceCount === 0 ?
                                        "The categories below are not required, but you may choose any or all of them if you want additional practice to improve your fluency."
                                        : this.props.freeChoiceCount === 1 ?
                                            `Please choose at least 1 category from the free choice list below in addition to any required categories. 
                                You may choose all of them if you want the additional practice to improve your fluency.`
                                            :
                                            `Please choose at least [` + this.props.freeChoiceCount + `] categories from the free choice list below, 
                                in addition to any required categories. You may choose all of them if you want the additional practice to improve your fluency.`
                                    }
                                </Typography>
                                :
                                <Typography id='practice-categories-instructions' component='p'
                                    fontSize={16} fontWeight={500}>
                                    Please choose at least 1 category from the list below and set goals. You may choose all of them if you want the additional practice to improve your fluency.
                                    {/* <br /><br />
                                    <div className='fontClass-14'>Please drag the slider or click + and - button to adjust the goal</div> */}
                                </Typography>
                            }
                            {this.state.loading ?
                                <div style={{ width: '100%', height: '100px' }} className='d-flex justify-content-center align-items-center'>
                                    <BeatLoader color={'#bb0000'} loading={true} size={15} />
                                </div>
                                :
                                <div className='mx-2 mt-4'>
                                    {this.props.practiceCount <= 0 ?
                                        this.state.categories.map((element, i) => (
                                            <div
                                                key={element.category_key}>
                                                <FormControlLabel
                                                    control={<Checkbox
                                                        size='small'
                                                        onChange={() => this.onRowClick(element.category_key)}
                                                        disabled={element.is_required === 1 ? true : false}
                                                        value={element.is_selected === 1 ? true : false}
                                                        checked={element.is_selected === 1 ? true : false}
                                                    />}
                                                    className='p-0 m-0'
                                                    label={element.is_required === 1 ? element.category_name + " (Required)" : element.category_name}
                                                />
                                            </div>
                                        ))
                                        :
                                        this.state.categories?.map((cat, catIndex) => {
                                            return (
                                                <Box
                                                    component='section'
                                                    aria-labelledby={`practice-category-${catIndex}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.onRowClick(cat.category_key)
                                                    }}
                                                    key={catIndex} boxShadow={cat.is_selected ? 4 : 0}
                                                    className="w-100 mb-3 d-flex justify-content-center align-items-center all-cat-card position-relative"
                                                    sx={{
                                                        borderRadius: '12px',
                                                        backgroundColor: cat.is_selected ? 'white' : '#DFDFDF',
                                                        cursor: 'pointer',
                                                        transform: cat.is_selected ? 'scale(1.02)' : 'scale(1)',
                                                        '&:hover': {
                                                            borderColor: cat.is_selected ? '#bb0000' : '#bb0000',
                                                            transform: 'scale(1.02)'
                                                        },
                                                    }}
                                                >

                                                    <Grid columnSpacing={4} rowSpacing={2} container className='h-100 w-100' justifyContent={'center'} alignItems={'center'}>
                                                        <Grid item md={4} xs={12}>
                                                            <div className='px-2 text-align-center d-flex justify-content-start align-items-center'>
                                                                <Checkbox
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        this.onRowClick(cat.category_key)
                                                                    }}
                                                                    checked={cat.is_selected}
                                                                    inputProps={{ 'aria-label': `Select ${cat.category_name}` }}
                                                                />
                                                                <Typography id={`practice-category-${catIndex}`} component='h2' className='text-align-left'>{cat.category_name}</Typography>
                                                            </div>
                                                        </Grid>
                                                        <Grid item md={4} xs={12} >
                                                            <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                                gap: '0.5rem'
                                                            }}>
                                                                <Typography component='h3' className='my-1' textAlign={'center'} fontWeight={600}>
                                                                    <span className='d-flex justify-content-center align-items-center' style={{
                                                                        gap: '0.3rem'
                                                                    }}>
                                                                        <SFInfoIcon helpText={"Percent of questions answered correctly. Default goal is 100%"} />
                                                                        <div>Accuracy %</div>
                                                                        {cat.isAccuracyGoalSet ?
                                                                            <div>

                                                                                <Tooltip
                                                                                    title={
                                                                                        <Typography fontSize={12} color='#fff'>
                                                                                            Reset to default accuracy goal
                                                                                        </Typography>
                                                                                    }
                                                                                    placement='top'>
                                                                                    <div className='goal-reset-btn'>
                                                                                        <IconButton
                                                                                            aria-label={`Reset accuracy goal for ${cat.category_name}`}
                                                                                            disabled={!cat.is_selected}
                                                                                            size='small'
                                                                                            color='primary'
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                this.handleResetAccuracyGoal(catIndex)
                                                                                            }}>
                                                                                            <FaUndo />
                                                                                        </IconButton>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            </div>
                                                                            : null}
                                                                    </span>
                                                                </Typography>
                                                                <div className='position-relative w-100'>
                                                                    <SFGoalSlider
                                                                        ariaLabel={`Accuracy goal for ${cat.category_name}`}
                                                                        handleGoalChange={(goal) => {
                                                                            this.handleAccuracyGoalChange(goal, catIndex)
                                                                        }}
                                                                        disabled={!cat.is_selected}
                                                                        min={0}
                                                                        max={100}
                                                                        step={10}
                                                                        goal={cat.accuracyGoal}
                                                                        previousGoal={cat.previousAccuracyGoal}
                                                                    />
                                                                </div>
                                                                <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                                    <TextField
                                                                        onClick={e => e.stopPropagation()}
                                                                        style={{ width: "50px" }}
                                                                        type='number'
                                                                        disabled
                                                                        className='sf-goal-input no-spinner'
                                                                        size='small'
                                                                        inputProps={{ style: { textAlign: 'right' }, 'aria-label': `Accuracy goal for ${cat.category_name}, percent` }}
                                                                        onChange={event => {
                                                                            event.stopPropagation();
                                                                            let val = event.target.value;
                                                                            if (val > 100) {
                                                                                val = 100;
                                                                            }
                                                                            this.handleAccuracyGoalChange(val, catIndex)
                                                                        }}
                                                                        value={cat.accuracyGoal}
                                                                    />
                                                                    <div className='ml-1' style={{ fontWeight: '600' }}>%</div>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                        <Grid item md={4} xs={12}>
                                                            <div className='h-100 position-relative d-flex flex-column justify-content-center align-items-center' style={{
                                                                gap: '0.5rem'
                                                            }}>
                                                                <Typography component='h3' className='my-1' textAlign={'center'} fontWeight={600}>
                                                                    <span className='d-flex justify-content-center align-items-center' style={{
                                                                        gap: '0.3rem'
                                                                    }}>
                                                                        <SFInfoIcon helpText={"Total time taken to complete this category. Default goal is median time for this semester"} /> <div>Time Taken (min)</div>
                                                                        {cat.isTimeGoalSet ?
                                                                            <div>
                                                                                <Tooltip
                                                                                    title={
                                                                                        <Typography fontSize={12} color='#fff'>
                                                                                            Reset to default time  goal
                                                                                        </Typography>
                                                                                    }
                                                                                    placement='top'>
                                                                                    <div className='goal-reset-btn'>
                                                                                        <IconButton
                                                                                            aria-label={`Reset time goal for ${cat.category_name}`}
                                                                                            disabled={!cat.is_selected}
                                                                                            size='small'
                                                                                            color='primary'
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                this.handleResetTimeGoal(catIndex)
                                                                                            }}>
                                                                                            <FaUndo />
                                                                                        </IconButton>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            </div>
                                                                            : null}
                                                                        {cat.previousAccuracyGoal < 80 ?
                                                                            <Tooltip
                                                                                title={
                                                                                    <Typography fontSize={12} color='#fff'>
                                                                                        Unlocking requires accuracy greater than 80%.
                                                                                    </Typography>
                                                                                }
                                                                                placement='top'>
                                                                                <div>

                                                                                    <FaLock aria-label='Time goal locked until accuracy exceeds 80 percent' role='img' />
                                                                                </div>
                                                                            </Tooltip>

                                                                            : null}
                                                                    </span>
                                                                </Typography>
                                                                <div className='position-relative w-100'>
                                                                    <SFGoalSlider
                                                                        type="time"
                                                                        ariaLabel={`Time goal for ${cat.category_name}, in minutes`}
                                                                        handleGoalChange={(goal) => {
                                                                            this.handleTimeGoalChange(goal, catIndex)
                                                                        }}
                                                                        disabled={!cat.is_selected || cat.previousAccuracyGoal < 80}
                                                                        min={0}
                                                                        max={10}
                                                                        step={1}
                                                                        goal={cat.timeGoal}
                                                                        previousGoal={cat.previousTimeGoal / 60}
                                                                        locked={cat.previousAccuracyGoal < 80}
                                                                    />
                                                                </div>
                                                                <div className='mt-2 d-flex justify-content-center align-items-center'>
                                                                    <TextField
                                                                        onClick={e => e.stopPropagation()}
                                                                        type='number'
                                                                        style={{ width: "50px" }}
                                                                        disabled={!cat.is_selected || cat.previousAccuracyGoal < 80}
                                                                        className='sf-goal-input no-spinner'
                                                                        size='small'
                                                                        inputProps={{ style: { textAlign: 'right' }, 'aria-label': `Time goal for ${cat.category_name}, in minutes` }}
                                                                        onChange={event => {
                                                                            event.stopPropagation();
                                                                            let val = event.target.value;
                                                                            this.handleTimeGoalChange(val, catIndex)
                                                                        }}
                                                                        value={cat.timeGoal}
                                                                    />
                                                                    <div className='ml-1' style={{ fontWeight: '600' }}>min</div>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            );
                                        })}
                                </div>
                            }

                            {/* <Typography fontSize={14}>
                            You may choose all of them if you want the additional practice to improve your fluency
                        </Typography> */}
                        </div>
                        {this.state.categories && this.state.categories.length ?
                            <div className='d-flex justify-content-center my-5'>
                                <Button className='sf-goal-submit-button' variant='contained' onClick={() => this.quizStartOnClick()}>Submit</Button>
                            </div>
                            : null}
                    </DialogContent>
                </div>


            </Dialog>
        </div>

    }
};

FreeChoiceCategorySelectionPage.propTypes = {
    freeChoiceCount: PropTypes.number,
    categoryIsRequired: PropTypes.array,
};

export default FreeChoiceCategorySelectionPage;